var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.4672H28.61",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.4672H4.26",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64388 14.4811C9.64388 16.0367 8.38281 17.2978 6.82719 17.2978C5.27157 17.2978 4.0105 16.0367 4.0105 14.4811C4.0105 12.9255 5.27157 11.6644 6.82719 11.6644C8.38281 11.6644 9.64388 12.9255 9.64388 14.4811Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.61 3.57919H0",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.52 3.57919H24",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9893 3.56669C23.9893 5.12231 22.7283 6.38338 21.1726 6.38338C19.617 6.38338 18.356 5.12231 18.356 3.56669C18.356 2.01108 19.617 0.75 21.1726 0.75C22.7283 0.75 23.9893 2.01108 23.9893 3.56669Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.c0a5b1746dad96c8494fa1b70bc484f4.svg";
export { ForwardRef as ReactComponent };